import Container from 'react-bootstrap/Container'
import HeroSearch from './HeroSearch'
import styles from './OnlineTutoringHero.module.scss'
import Image from 'next/image'
import backgroundImage from '../public/images/online-tutoring-bg.jpg'

// const styles = {}

export default function OnlineTutoringHero() {
  return (
    <div className={styles.heroContainer}>
      <div className={styles.overlay}></div>

      <Image
        src={backgroundImage}
        className={styles.backgroundImage}
        alt="Cover photo"
        priority
        fill
        sizes="100vw"
        style={{
          objectFit: "cover",
          objectPosition: "center"
        }} />

      <div className={styles.content}>
        <Container className="pt-lg-4">
          <div className="pb-2 pt-5 pb-lg-4 text-center">
            <h1 className="text-white pb-2">
              <strong>
                Expert tutoring online, wherever you are
              </strong>
            </h1>
            <p className="h5 text-white">
              Learn with the best tutors right from your laptop or tablet
            </p>
          </div>

          <div className="pt-2 mb-5">
            <div className={`${styles.searchContainer} p-3 p-lg-5`}>
              <div className={styles.controlOverlay} />

              <HeroSearch modality="online" showModalityControl={false} />
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}
